// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__23_cJ","leftCol":"styles_leftCol__dxFUO","rightCol":"styles_rightCol__7sNr1","rightColMobile":"styles_rightColMobile__ZAKQk"};